import * as React from "react"
import { slugify } from "../../custom_utils/helpers"
import { Block } from "./library/container"

export interface HighlightBlockProps {
  readonly kind: "highlight"
  readonly title: string
  readonly subtitle: string
  readonly content: string
}

export const HighlightBlock: (props: HighlightBlockProps) => JSX.Element = p => (
  <Block>
    <div className="highlight">
      <h2 data-anchor={slugify(p.title)} className="highlight__title title--s">{p.title}</h2>
      <div className="highlight__subtitle">{p.subtitle}</div>
      <div className="highlight__text" dangerouslySetInnerHTML={{ __html: p.content }} />
    </div>
  </Block>
)
